import { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Button } from 'antd';
import { useLocationState } from '../../hooks';
import {
    getUsersEmail,
    prepareHubspotData,
    sendToAmplitude,
    sendToHubspot,
    sendToGtm,
    useFormData
} from '../../model';
import Users from './users.svg';
import s from './index.module.css';

const grades = ['1-50', '50-250', '250-500', '500-1000', '1000+'];

export const Employees = () => {
    const { email, setEmail, nextStep } = useFormData();
    const [{ query }] = useLocationState();
    const [answer, setAnswer] = useState('');

    const handleChoose = useCallback((team_size: string) => {
        setAnswer(team_size);
        sendToAmplitude(`WALLARMCOM_AASM_TEAM`);
    }, []);

    const isSSOMethod = () => {
        if (query.signup_method === 'sso') {
            const ssoProvider = localStorage.getItem('sso_provider');
            const eventName =
                ssoProvider === 'azure_activedirectory_v2'
                    ? 'aasm_sso_microsoft_click'
                    : 'aasm_sso_google_click';

            sendToGtm(eventName, {
                email
            });

            // Clean up localStorage after use
            localStorage.removeItem('sso_provider');
        }
    };

    const handleNext = useCallback(async () => {
        sendToAmplitude(`WALLARMCOM_AASM_TEAM_SUBMITTED`, { team_size: answer });

        isSSOMethod();

        await sendToHubspot(prepareHubspotData({ email, team_size: `${answer} Employees` }));
        nextStep('role');
    }, [email, answer]);

    const initUserInfo = async () => {
        const userEmail = await getUsersEmail();
        if (userEmail) setEmail(userEmail);
    };

    useEffect(() => {
        if (!email) initUserInfo();
    }, []);

    return (
        <>
            <div className={s.block}>
                {grades.map(item => (
                    <div
                        key={item}
                        className={classNames(s.item, item === answer && s.checked)}
                        onClick={() => handleChoose(item)}
                    >
                        <img src={Users} alt='team' className={s.icon} />
                        <div className={s.text}>{item}</div>
                        <div className={s.desc}>Employees</div>
                    </div>
                ))}
            </div>
            <div className={s.actions}>
                <Button type='primary' size='large' disabled={!answer} onClick={handleNext}>
                    Next
                </Button>
            </div>
        </>
    );
};
